module.exports = __webpack_public_path__ + "img/shield.7ba1ed89.svg";